import { useQuery } from "@tanstack/react-query";
import { config } from "../config/hedera";

const POLLING_INTERVAL = 60000;
const HEDERA = "HEDERA";

const token = process.env.NEXT_PUBLIC_TOKEN || "";

export const useHederaMaintenance = () => {
  const { data } = useQuery({
    queryKey: ["dapp-sdk", "hedera", "maintenance"],
    queryFn: async () => {
      const resp = await fetch(config.underMaintainanceURL);
      return resp.json();
    },
    enabled: token === HEDERA,
    refetchInterval: POLLING_INTERVAL,
  });

  return !!data?.isActive;
};
